import { BehaviorSubject, takeUntil } from 'rxjs';
import { LayerStyle, MapboxLayerType } from './layer.type';
import { LayerGroup } from './layer-group.model';

export class BaseLayer {
  public id: string;
  public name: string;
  public style?: { layerType?: MapboxLayerType; } & LayerStyle | { layerType?: 'html-marker'; sourceType?: 'geojson'; } & LayerStyle;

  protected mapRef: mapboxgl.Map;
  protected readonly isVisibleBS = new BehaviorSubject(false);
  public readonly isVisible$ = this.isVisibleBS.asObservable();

  protected layerGroup: LayerGroup;

  protected readonly isSelectedBS = new BehaviorSubject(false);
  public readonly isSelected$ = this.isSelectedBS.asObservable();

  constructor() {}

  public toggleIsSelected() {
    this.setIsSelected(!this.isSelectedBS.getValue());

    // show group when the first layer within is shown
    if (
      this.getIsSelected() &&
      this.layerGroup &&
      !this.layerGroup.getIsVisible() &&
      this.layerGroup.layers.filter(layer => layer.getIsSelected()).length === 1
    ) {
      this.layerGroup.setVisibility(true);
    }
  }
  public setIsSelected(selected: boolean) {
    this.isSelectedBS.next(selected);
    const isGroupVisible = this.layerGroup?.getIsVisible();
    if (isGroupVisible) {
      this.setVisibility(selected);
    } else {
      this.setVisibility(false);
    }
  }
  public getIsSelected() {
    return this.isSelectedBS.getValue();
  }

  public toggleVisibility() {
    this.setVisibility(!this.isVisibleBS.getValue());
  }
  public setVisibility(isVisible: boolean, forceGroupVisibility = false) {
    if (this.layerGroup && forceGroupVisibility) {
      this.setIsSelected(isVisible);
      this.layerGroup.setVisibility(isVisible);
    } else {
      if (this.mapRef.getLayer(this.id)) {
        this.mapRef.setLayoutProperty(this.id, 'visibility', isVisible ? 'visible' : 'none');
      }
      this.style.visible = isVisible;
      this.isVisibleBS.next(isVisible);
    }
  }
  public getIsVisible() {
    return this.isVisibleBS.getValue();
  }

  public setLayerGroup(group: LayerGroup) {
    this.layerGroup = group;
  }
}
